import { create } from 'zustand'
import { User } from '@/interfaces/user'

export interface AuthState {
  isAuthenticated: boolean
  token: string | null
  user: User | null
}
interface AuthStore extends AuthState {
  setAuth: (auth: AuthState) => void
  clearAuth: () => void
}

// Initialize from localStorage
const getInitialAuthState = (): AuthState => {
  const token = localStorage.getItem('token')
  const userStr = localStorage.getItem('user')

  if (token && userStr) {
    try {
      const user = JSON.parse(userStr)
      return {
        isAuthenticated: true,
        token,
        user,
      }
    } catch (error) {
      console.error('Failed to parse user from localStorage:', error)
    }
  }

  return {
    isAuthenticated: false,
    token: null,
    user: null,
  }
}

export const useAuthStore = create<AuthStore>((set) => ({
  ...getInitialAuthState(),
  setAuth: (auth: AuthState) => set(auth),
  clearAuth: () =>
    set({
      isAuthenticated: false,
      token: null,
      user: null,
    }),
}))
